const args = {}

function assintStringParams(str) {
  if (!str) return
  for(let item of str.split('&')) {
    let parts = item.split('=')
    let name = decodeURIComponent(parts[0])
    let value = parts.length > 1 ? decodeURIComponent(parts[1]) : null
    args[name] = value
  }
}

if (location.search) {
  assintStringParams(location.search.substring(1))
}

if (location.hash) {
  const pos = location.hash.indexOf('?')
  if (pos >= 0) {
    assintStringParams(location.hash.substring(pos + 1))
  }
}

export function getQueryParam(name, defaultValue) {
  if (name in args) {
    let val = args[name]
    if (val !== null && val !== undefined && val !== '') {
      return val
    }
  }
  return defaultValue
}

export default args
